export default __webpack_public_path__ + "static/media/transfer-send-step2.d032c090.png";